import { useRef, useEffect, useState } from 'react';
import {
    Autocomplete,
    CircularProgress,
    TextField
} from '@mui/material';

const SearchAutocomplete = ({
    label = 'Selecione',
    options = [],
    value = null,
    onChange,
    onSearch,
    getOptionLabel,
    loading = false,
    minSearchLength = 2,
    debounceTime = 400,
    disabled = false,
    ...props
}) => {
    const [inputValue, setInputValue] = useState('');
    const timeoutRef = useRef(null);
    const previousValueRef = useRef(value);
    const selectionRef = useRef(false);

    useEffect(() => {
        if (previousValueRef.current !== value && selectionRef.current) {
            setInputValue(value ? getOptionLabel(value) : '');
        }

        previousValueRef.current = value;
        selectionRef.current = false;
    }, [value, getOptionLabel]);

    const handleInputChange = (event, newValue, reason) => {
        setInputValue(newValue);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (reason === 'input') {
            if (newValue.length >= minSearchLength) {
                timeoutRef.current = setTimeout(() => {
                    const splitedValue = newValue.split(' - ');
                    const searchValue = splitedValue.length > 1 ? splitedValue[1] : splitedValue[0];
                    onSearch?.(searchValue);
                }, debounceTime);
            }

            if (newValue.length === 0) {
                onSearch?.(null);
            }
        }

        if (reason === 'clear') {
            onSearch?.(null);
        }
    };

    const getOptionValue = (option) => {
        if (!option) return null;

        if (typeof option === 'string') {
            return option.split(' - ')[0];
        }

        return option.Id;
    };

    return (
        <Autocomplete
            {...props}
            fullWidth
            options={options}
            loading={loading}
            disabled={disabled}
            filterOptions={(options) => options}
            value={value}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            onChange={(event, newValue) => {
                selectionRef.current = true;
                onChange?.(newValue);
            }}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={(option, selectedValue) =>
                selectedValue != null &&
                String(getOptionValue(option)) ===
                String(getOptionValue(selectedValue))
            }
            noOptionsText="Nenhum resultado encontrado"
            loadingText="Buscando..."
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && (
                                    <CircularProgress
                                        color="inherit"
                                        size={20}
                                    />
                                )}

                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
            sx={{
                minWidth: 200,
                '& .MuiInputBase-root': {
                    height: '45px'
                }
            }}
        />
    );
};

export default SearchAutocomplete;